/**
 * URL-safe slug from a name that may be Hebrew.
 *
 * Hebrew letters cannot appear in a slug that also has to work as a folder
 * name on every platform and inside a URL without percent-encoding, so each
 * Hebrew character becomes `he-<codepoint>`. Ugly, stable, reversible enough,
 * and it matches what the settings catalogs already do.
 */
export function slugify(input: string): string {
  const out = input
    .trim()
    .toLowerCase()
    .replace(/[֐-׿]/g, (ch) => `he-${ch.charCodeAt(0).toString(16)}`)
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
    .replace(/^-+|-+$/g, '');
  return out || `skill-${Date.now().toString(36)}`;
}
